import React, { useEffect, useRef } from "react";

const defaultStyle = {
  display: "block",
  resize: "none",
  width: "100%",
  minHeight: "55px",
};

const AutoHeightTextarea = ({ style = defaultStyle, value, setMessage }) => {
  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current) {
      // Reset height to calculate based on content
      textareaRef.current.style.height = "0px";
      textareaRef.current.style.height = textareaRef.current.scrollHeight + "px";
    }
  }, [value, setMessage]);

  return (
    <textarea
      ref={textareaRef}
      style={style}
      value={value}
      className="border border-[#cccccc] rounded-xl p-2 overflow-y-auto max-h-[200px]"
      onChange={(e) => setMessage(e.target.value)}
    />
  );
};

export default AutoHeightTextarea;
